import { Box } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import NoResultsMessage from "../../components/NoResultsMessage";
import ScenariosSetCard from "./ScenariosSetCard";

const ScenariosSetCards = ({
  rows,
  setSelectedScenarioSet,
  fullScreen,
  resetFilters,
}) => {
  const colors = useColors();

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"right"}
      padding={1}
      paddingLeft={"1px"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"right"}
        gap={1}
        sx={{
          height: "80vh",
          overflowY: "auto",
          padding: "2px 20px 14px 8px",
          margin: 0,
          borderRadius: "24px 24px 0px 0px",
          width: "100%",
          backgroundColor: colors.common_white,
          transition: "height 0.3s ease-in-out",
        }}
      >
        {rows?.length > 0 ? (
          rows?.map((row, index) => (
            <ScenariosSetCard
              key={`scenario-set-card-${index}`}
              row={row}
              setSelectedScenarioSet={setSelectedScenarioSet}
              index={index}
              fullScreen={fullScreen}
            />
          ))
        ) : (
          <NoResultsMessage resetFilters={resetFilters} />
        )}
      </Box>
    </Box>
  );
};

export default ScenariosSetCards;
